import { render } from "./View01.vue?vue&type=template&id=5fcd83ac&scoped=true"
import script from "./View01.vue?vue&type=script&lang=js"
export * from "./View01.vue?vue&type=script&lang=js"

import "./View01.vue?vue&type=style&index=0&id=5fcd83ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcd83ac"]])

export default __exports__